import { createClasses } from 'src/utils/create-classes';
// ----------------------------------------------------------------------

export const svgColorClasses = {
  root: createClasses('svg__color__root'),
};
